<form [formGroup]="payHistory">
    <div class="col-lg-12">
        <div class="card-body">
            <div>
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/images/history.gif" class="mh-45px pb-2">
                    <div class="ml-2">
                        <h2 class="main-content-label mb-1 ml-2">
                            <b>Payment History
                            </b>
                        </h2>
                    </div>
                </div>
            </div>
            <div class="row clearfix">
                <div class="table-responsive mt-4 widthTb">
                    <table id="datatable" class="table table-bordered text-nowrap">
                        <thead>
                            <tr>
                                <th width="10%" class="f600">Fee Head</th>
                                 <th width="20%" class="f600">Fee Paid</th>
                                 <th width="30%" class="f600">Date & Time</th>

                            </tr>
                        </thead>

                        <tbody id="table_data">
                           <tr *ngFor="let item of payHistoryData; let i = index">
                               <td>{{item.Head}}</td>
                                <td *ngIf="Currency == 'INR' ">
                                    <span class="currency-symbolTd">&#8377; </span>    {{item.FeeAmt}}
                                </td>
                                <td *ngIf="Currency == 'USD' ">
                                    <span class="currency-symbolTd">$ </span>     {{item.FeeAmt}}
                                </td>
                                <td>
                                    <!-- {{item.FeePaymentDate }} -->
                                    {{ convertUTCToIST(item.FeePaymentDate) }}
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-sm-12">
                    <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1 fr"
                        (click)="close()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/images/letter-x.gif" style="margin-right: 7px;">
                            Close
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>